import { scheduleConstants } from '../../_constants';
import { scheduleServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';
import { generateExcel } from '../../../components/voyage/schedule/GenerateExcelReport';
export const scheduleActions = {
    load,
    getVoyageScheduleByVoyageNum,
    createVoyageSchedules,
    editVoyageSchedules,
    deleteVoyageSchedules,
    activation,
    scheduleReport,
    getDestinationFromVoyageScheduleByVoyageNum,
    approveSchedule,
    updateCROStatus,
};

function scheduleFetching() { return { type: scheduleConstants.SCHEDULE_FETCHING } }
function scheduleFetched() { return { type: scheduleConstants.SCHEDULE_FETCHED } }

function scheduleSubmitting() { return { type: scheduleConstants.SCHEDULE_SUBMITTING } }
function scheduleSubmitted() { return { type: scheduleConstants.SCHEDULE_SUBMITTED } }

function load(skip, take, filter, search) {
    return dispatch => {
        dispatch(scheduleFetching());
        dispatch(userActions.allowLeavePage());
        scheduleServices.load(skip, take, filter, search)
            .then(
                schedules => {
                    if (schedules.length > 0) {
                        dispatch(success(schedules));
                        dispatch(scheduleFetched());
                    } else {
                        dispatch(alertActions.warning(schedules.message))
                        dispatch(scheduleFetched());
                    }
                },
                error => {
                    dispatch(scheduleFetched());
                    dispatch(alertActions.warning(error.toString()));
                }
            );
    };
    function success(schedules) { return { type: scheduleConstants.LIST_OF_SCHEDULES, schedules } }
}

function getVoyageScheduleByVoyageNum(voyageNum) {
    return dispatch => {
        dispatch(scheduleFetching());
        scheduleServices.getVoyageScheduleByVoyageNum(voyageNum)
            .then(
                schedule => {
                    dispatch(success(schedule))
                    dispatch(scheduleFetched());
                },
                error => {
                    dispatch(scheduleFetched());
                    dispatch(alertActions.warning(error.toString()));
                }
            );
    };
    function success(schedule) { return { type: scheduleConstants.GET_SCHEDULE_BY_ID, schedule } }
}

function createVoyageSchedules(payload) {
    return dispatch => {
        dispatch(scheduleSubmitting());
        dispatch(userActions.notallowLeavePage());
        scheduleServices.createVoyageSchedules(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(alertActions.success('Voyage schedule added successfully'))
                    window.location.href = '/voyage/schedules';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function editVoyageSchedules(payload, id, approve) {
    return dispatch => {
        dispatch(scheduleSubmitting());
        dispatch(userActions.notallowLeavePage());
        scheduleServices.editVoyageSchedules(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(alertActions.success('Voyage schedule updated successfully'));
                    if (approve) {
                        dispatch(confirmPromptActions.hide());
                        dispatch(getVoyageScheduleByVoyageNum(id))
                    } else {
                        window.location.href = '/voyage/schedules';
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function deleteVoyageSchedules(id, type, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        scheduleServices.deleteVoyageSchedules(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Voyage schedule deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/voyage/schedules';
                            break;
                        default:
                            dispatch(load(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getVoyageScheduleByVoyageNum(id));
                            break;
                        default:
                            dispatch(load(0, take));
                            break;
                    }
                }
            );
    };
}

function activation(id, isActive) {
    return dispatch => {
        dispatch(scheduleSubmitting());
        dispatch(userActions.notallowLeavePage());
        scheduleServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getVoyageScheduleByVoyageNum(id));
                    dispatch(alertActions.success(isActive ? 'Voyage schedule activated successfully' : 'Voyage schedule deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function scheduleReport(from, to, vessel) {
    return dispatch => {
        dispatch(scheduleFetching());
        dispatch(userActions.notallowLeavePage());
        scheduleServices.scheduleReport(from, to, vessel)
            .then(
                scheduleReport => {
                    dispatch(userActions.allowLeavePage());
                    if (scheduleReport.length > 0) {
                        generateExcel(scheduleReport);
                        dispatch(scheduleFetched());
                    } else {
                        dispatch(alertActions.warning(scheduleReport.message))
                        dispatch(scheduleFetched());
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function getDestinationFromVoyageScheduleByVoyageNum(voyageNum) {
    return dispatch => {
        dispatch(scheduleFetching());
        scheduleServices.getDestinationFromVoyageScheduleByVoyageNum(voyageNum)
            .then(
                destinationsFromSchedule => {
                    dispatch(success(destinationsFromSchedule))
                    dispatch(scheduleFetched());
                },
                error => {
                    dispatch(scheduleFetched());
                    dispatch(alertActions.warning(error.toString()));
                }
            );
    };
    function success(destinationsFromSchedule) { return { type: scheduleConstants.DESTINATIONS_LIST_FROM_SCHEDULE, destinationsFromSchedule } }
}

function approveSchedule(voyageNum) {
    return dispatch => {
        dispatch(scheduleSubmitting());
        dispatch(userActions.notallowLeavePage());
        scheduleServices.approveSchedule(voyageNum)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getVoyageScheduleByVoyageNum(voyageNum));
                    dispatch(alertActions.success('Voyage schedule approved successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getVoyageScheduleByVoyageNum(voyageNum));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function updateCROStatus(voyageNum, status) {
    return dispatch => {
        dispatch(scheduleSubmitting());
        dispatch(userActions.notallowLeavePage());
        scheduleServices.updateCROStatus(voyageNum, status)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Update CRO Status successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(scheduleSubmitted());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}